<!--
 * @Author: wumao
 * @Date: 2021-11-24 10:51:08
 * @LastEditors: wumao
 * @LastEditTime: 2021-11-30 15:25:28
 * @Description: pdf封面
-->
<template>
  <div class="cover">
    <div class="logo">
      <div class="img-wrapper">
        <img src="@/assets/images/zhuanye.png" alt="LOGO" />
      </div>
      <p class="desc">专业版</p>
    </div>
    <div class="info">
      <h3>专精特新小巨人测评报告</h3>
    </div>
    <div class="company-info">
      <div class="company-name">{{ resultData.orgName }}</div>
      <div class="time">报告生成：{{ currentData }}</div>
      <!-- <div class="company">报告出具单位：汉唐信通（北京）咨询股份有限公司</div> -->
    </div>

    <div class="bottom-tip">
      <span class="title">声明：</span>
      <span>测评结果为公司宝基于用户选择结果和企业大数据通过算法计算分析的结果，数据仅供参考，并非最终申报成功与否的保证或承诺，不具备法律效力。</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    resultData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      currentData: '',
    }
  },
  created() {
    this.currentData = this.getCurrentTime()
  },
  methods: {
    getCurrentTime() {
      let date = new Date()
      let y = date.getFullYear()
      let m = `0${date.getMonth() + 1}`.slice(-2)
      let d = `0${date.getDate()}`.slice(-2)
      // let h = `0${date.getHours()}`.slice(-2)
      // let mm = `0${date.getMinutes()}`.slice(-2)
      return `${y}年${m}月${d}日`
    },
  },
}
</script>

<style lang="less" scoped>
.cover {
  position: relative;
  width: 800px;
  height: 1200px;
  box-sizing: border-box;
  background-color: #3264fd;
  background-image: url('~@/assets/images/cover.png');
  background-size: cover;
  background-repeat: no-repeat;
  .logo {
    position: absolute;
    width: 60px;
    top: 100px;
    right: 50px;
    img {
      width: 60px;
      height: 60px;
    }
    .desc {
      text-align: center;
      font-size: 16px;
      font-weight: 400;
      color: #ffffff;
      line-height: 36px;
      color: #a6bbfe;
    }
  }
  .info {
    position: absolute;
    width: 100%;
    text-align: center;
    top: 40%;
    left: 50%;
    transform: translate(-50%, -50%);
    h3 {
      font-size: 44px;
      font-weight: 500;
      color: #ffffff;
      line-height: 80px;
      opacity: 0.9;
    }
    p {
      font-size: 24px;
      font-weight: 500;
      color: #ffffff;
      line-height: 54px;
      opacity: 0.8;
    }
  }
  .company-info {
    position: absolute;
    font-size: 18px;
    font-weight: 500;
    color: #ffffff;
    right: 60px;
    bottom: 150px;
    text-align: right;
    .company-name {
      font-size: 30px;
      margin-bottom: 10px;
    }
    .time,
    .company {
      font-weight: 400;
      font-size: 16px;
      opacity: 0.9;
      margin-bottom: 10px;
    }
  }
  .bottom-tip {
    position: absolute;
    bottom: 40px;
    right: 0;
    font-size: 14px;
    text-align: left;
    color: #fff;
    padding: 0 20px;
    opacity: 0.5;
    display: flex;
    .title {
      width: 60px;
    }
  }
}
</style>
